import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { StatusLabelComponent } from '@principle-theorem/ng-principle-shared';
import {
  type WebhookStatus,
  WEBHOOK_STATUS_MAP,
} from '@principle-theorem/principle-core/interfaces';

@Component({
  selector: 'pr-webhook-status',
  templateUrl: './webhook-status.component.html',
  styleUrls: ['./webhook-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [StatusLabelComponent],
})
export class WebhookStatusComponent {
  @Input() status: WebhookStatus;
  @Input({ transform: coerceBooleanProperty }) dense = false;
  statusColourMap: {
    [key in WebhookStatus]: string;
  } = WEBHOOK_STATUS_MAP;
}
